export default __webpack_public_path__ + "static/media/p10.f9698dbf.jpg";